import Vue from 'vue';
import './plugins/vuetify';
import  Vuetify from 'vuetify';
import App from './App.vue';
import VueRouter from 'vue-router';
import Home from './components/Home';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import store from './store'

Vue.config.productionTip = false;

const routes = [
  { path: '/', name:'root', component: Home },
  { path: '/home', name:'home', component: Home },
  { path: '/gallery', name:'gallery', component: Gallery },
  { path: '/contact', name:'contact', component: Contact },
];

const router = new VueRouter({
  routes, // short for `routes: routes`
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
}});

Vue.use(Vuetify, {
  theme: {
    primary: '#3f51b5',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c',
    background: '#FFF8DC'
  }
});

Vue.use(VueRouter);

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
